<template>
  <v-app ref="mainApp" style="min-height: 100vh; background-color: #eee!important;" class="grey lighten-3">
    <v-app-bar v-if="showMainBar" flat app color="primary" dark class="mb-3">
      <router-link :to="{ name: 'Home'}">
        <v-btn link text class="mx-1">
          <v-img alt="UCPA" class="shrink" :src="require('@/assets/ucpa.svg')" height="65" width="100" />
        </v-btn>
      </router-link>
      <v-chip class="mr-3 black--text" color="white" small>CRM</v-chip>
      <v-btn v-if="isFromPegase && isCustomerRoute" color="blue" small class="white--text" @click="returnToPegase">Retour sur Pégase</v-btn>
      <div v-if="isReturnToPegase">
        <v-btn color="blue" small class="white--text" :loading="loading" @click="updateCustomerShowOnPlanner">Pegase</v-btn>
        <v-chip class="ml-3 black--text" color="white" small>{{ customerSelectedAmount }} sélectionné(s)</v-chip>
      </div>
      <v-btn v-if="isFromHello && isCustomerRoute" color="green" small class="white--text" @click="returnToHello">Retour sur Hello</v-btn>
      <div v-if="isReturnToHello">
        <v-btn color="green" small class="white--text" :loading="loading" @click="sendCustomersToHello">Hello</v-btn>
        <v-chip class="ml-3 black--text" color="white" small>{{ customerSelectedAmount }} sélectionné(s)</v-chip>
      </div>

      <v-spacer />
      <SearchBar />
      <v-spacer />
      <v-btn v-if="$store.state.iResa.urlRetour" class="mx-4" outlined @click="goBackToIresa()">
        <v-icon>mdi-page-previous-outline</v-icon>
        <span class="ml-2 d-none d-sm-inline-block">Retour vers Iresa</span>
      </v-btn>
      <v-select
        v-model="brand"
        style="max-width: 200px;"
        class=" d-none d-sm-flex"
        :items="brands"
        hide-details
        item-text="label"
        item-value="value"
        outlined
        dense
      />

      <UserInfo />
    </v-app-bar>

    <v-app-bar v-if="$store.state.addContactMode.active" flat app color="primary" dark class="mb-3">
      <v-chip
        class="px-0 mr-2"
        color="transparent"
        @click="cancelAddCustomer()"
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-chip>
      <h2 class="d-none d-inline-block mr-2 pt-1">
        Ajouter contact
      </h2>
      <v-spacer />
      <SearchBar />
      <v-spacer />
    </v-app-bar>

    <v-app-bar v-if="$store.state.duplicateContactMode.active" flat app color="primary" dark class="mb-3">
      <v-chip
        class="px-0 mr-2"
        color="transparent"
        @click="cancelDuplicateCustomer()"
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-chip>
      <h2 class="d-none d-inline-block mr-2 pt-1">
        Duplicate contact
      </h2>
    </v-app-bar>

    <v-main>
      <router-view v-if="loaded" />
      <Notification />
      <PaymentNotification :payments="payments" />
    </v-main>
    <v-footer id="footer-style" padless>
      <v-col class="text-center grey--text text--darken-2" cols="12">
        {{ new Date().getFullYear() }} — <strong>UCPA</strong>
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
import { utils, requests } from '@/mixins/index';
import SearchBar from './components/search/SearchBar';
import UserInfo from './components/UserInfo';
import Notification from '@/components/Notification';
import PaymentNotification from '@/components/PaymentNotification';
import { getUser } from '@/utils/auth';

const { VUE_APP_SSO_PUBLIC_JWK_SET } = process.env;

export default {
  name: 'App',
  components: {
    SearchBar,
    UserInfo,
    Notification,
    PaymentNotification
  },
  mixins: [utils, requests],
  data () {
    return {
      loaded: true,
      loading: false,
      brands: [
        { label: 'UCPA', value: 'crm', iresaContextId: '1' },
        // { label: 'TELLIGO', value: 'crm_telligo', iresaContextId: '2' },
        { label: 'LA BALAGUERE', value: 'crm_labalaguere', iresaContextId: '2' }
      ]
    };
  },
  computed: {
    payments () {
      return this.$store.state.alphaPaymentsToSync;
    },
    brand: {
      get () {
        return this.$store.state.brand;
      },
      set (newValue) {
        this.$store.commit('setBrand', newValue);
        this.$router.push({ name: 'Home' }).catch(error => {
          if (error.name !== 'NavigationDuplicated') {
            throw error;
          }
        });
      }
    },
    isProd () {
      return process.env.VUE_APP_ENVIRONMENT === 'production';
    },
    customerSelected () {
      return this.$store.state.selectedCustomers;
    },
    customerDeselected () {
      return this.$store.state.deselectedCustomers;
    },
    customerSelectedAmount () {
      return this.customerSelected.length;
    },
    showMainBar () {
      return !this.$store.state.addContactMode.active && !this.$store.state.duplicateContactMode.active;
    },
    isFromPegase () {
      return this.$store.state.fromPegase;
    },
    isFromHello () {
      return this.$store.state.fromHello;
    },
    isCustomerRoute () {
      return this.$route && this.$route.name === 'Customer';
    },
    isReturnToPegase () {
      return this.$store.getters.isReturnToPegase;
    },
    isReturnToHello () {
      return this.$store.getters.isReturnToHello;
    }
  },
  async mounted () {
    this.loaded = false;
    this.$store.commit('setUser', await getUser(this.$store.state.token, window.location.origin));

    await this.$router.onReady(async () => {
      // Accept both urlRetour/urlretour and urlValid/urlvalid (case-insensitive)
      const urlRetour = this.$route.query.urlRetour || this.$route.query.urlretour;
      const urlValid = this.$route.query.urlValid || this.$route.query.urlvalid;

      if (urlRetour || urlValid) {
        //Example:
        // ...?urlRetour=https%3A%2F%2Fbo-iresa.ucpa.com%2Fdossier%2FVenteRead.aspx&urlValid=https%3A%2F%2Fbo-iresa.ucpa.com%2Fdossier%2FVenteRead.aspx%3Fcontext_id%3D%24CONT_ID%24%26context_select%3Dcontact&rese_id=1

        this.$store.commit('setIresa', { urlRetour, urlValid });
      }

      if (this.$route.query && this.$route.query.fromPegase) {
        this.$store.commit('setFromPegase', true);
      }

      if (this.$route.query && this.$route.query.fromHello && this.$route.query.helloGroup) {
        this.$store.commit('setFromHello', true);
        this.$store.commit('setHelloGroup', this.$route.query.helloGroup);
      }

      if (this.$route.query && this.$route.query.returnTo === 'pegase' && this.$route.query.workspace) {
        this.$store.commit('setReturnTo', 'pegase');
        this.$store.commit('setAlphaWorkspace', this.$route.query.workspace);
      }

      if (this.$route.query && this.$route.query.returnTo === 'hello' && this.$route.query.helloGroup) {
        this.$store.commit('setReturnTo', 'hello');
        this.$store.commit('setHelloGroup', this.$route.query.helloGroup);
      }

      const user = await getUser(this.$store.state.token, window.location.origin);

      this.$store.commit('setUser', user);
      if (!user.readWorkspaces.includes('*')) {
        this.brands = this.brands.filter(brand => user.readWorkspaces.includes(brand.value));
      }

      // Find the current brand by iresa_id
      let brandValue = this.brands[0].value;

      if (this.$route.query.rese_id) {
        const foundedBrand = this.brands.find(brand => brand.iresaContextId === this.$route.query.rese_id);

        if (foundedBrand) brandValue = foundedBrand.value;
      } else if (this.$route.query && this.$route.query.brand) {
        const newBrand = this.$route.query.brand;
        const values = this.brands.map(brand => brand.value);
        if (values.includes(newBrand)) {
          brandValue = newBrand;
        }
      }

      this.$store.commit('setBrand', brandValue);

    });

    await Promise.allSettled([this.alphaWorkspaces(), this.loadDeactivatedPartners()]);

    this.loaded = true;
  },
  methods: {
    async alphaWorkspaces () {
      const response = await this.getAlphaWorkspaces();
      this.$store.commit('setAlphaWorkspaces', response.data);
    },
    async loadDeactivatedPartners () {
      const response = await this.getDeactivatedPartners();
      if (response && response.success) {
        this.$store.commit('setDeactivatedPartners', response.data || []);
      }
    },
    async updateCustomerShowOnPlanner () {
      this.loading = true;
      const uuids = (this.customerSelected || []).map(c => c.uuid);
      const deselectedUuids = (this.customerDeselected || []).map(c => c.uuid);

      const response = await this.updateCustomerWorkspace(uuids, deselectedUuids, this.$store.state.alphaWorkspace);
      if (response.success) {
        this.$store.commit('setReturnTo', null);
        this.$store.commit('setSelectedCustomer', []);
        this.$store.commit('setDesselectedCustomer', []);
        this.$store.commit('setAlphaWorkspace', null);
        window.location.href = `${process.env.VUE_APP_PEGASE_URL}?from=crm`;
      }

      this.loading = false;
    },
    sendCustomersToHello () {
      const uuids = (this.customerSelected || []).map(c => c.uuid);
      const url = `${process.env.VUE_APP_HELLO_URL}/groupe/${this.$store.state.helloGroup}?users=${uuids.join(',')}`;
      this.$store.commit('setFromHello', false);
      this.$store.commit('setReturnTo', null);
      this.$store.commit('setSelectedCustomer', []);
      this.$store.commit('setDqesselectedCustomer', []);
      this.$store.commit('setHelloGroup', null);

      window.location.href = url;
    },
    returnToPegase () {
      this.$store.commit('setFromPegase', false);
      window.location.href = `${process.env.VUE_APP_PEGASE_URL}/customer/${this.$route.params.uuid}`;
    },
    returnToHello () {
      this.$store.commit('setFromHello', false);
      window.location.href = `${process.env.VUE_APP_HELLO_URL}`; // TODO url
    },
    cancelAddCustomer () {
      this.$store.commit('setAddContactMode', { active: false });
      this.$router.push({
        name: 'Customer',
        params: { uuid: this.$store.state.addContactMode.customer_uuid }
      });
    },
    cancelDuplicateCustomer () {
      this.$store.commit('setDuplicateContactMode', { active: false });
      this.$router.push({
        name: 'Customer',
        params: { uuid: this.$store.state.duplicateContactMode.customer.uuid }
      });
    },
    goBackToIresa () {
      const { urlRetour } = this.$store.state.iResa;
      // this.$store.commit('setIresa', {});
      window.location.href = urlRetour;
    }
  }
};
</script>

<style>
.row{
    margin: 0 !important;
}

#footer-style {
  border-top: 1px solid rgba(0,0,0,.12);
}

.vts .v-snack__content {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
